export const apis = {
  templateConfig: {
    getAll: "/api/v1/template-configs",
    getByID: "/api/v1/template-configs", // '/{id}'
  },

  provider: {
    url: "/api/v1/providers",
    getAll: "/api/v1/providers",
    getByID: "/api/v1/providers", // '/{id}'
    getByAdmin: "/api/v1/providers/by-admin",
  },

  searchImage: {
    search: "/api/v1/search", // post
    getHistoryByUser: "/api/v1/history-searching/by-user",
  },



  cart: {
    addImage: "/api/v1/carts/items",
    delImage: "/api/v1/carts/remove-image-to-cart",
    getImage: "/api/v1/carts/me",
    getProductBunbleByItemType: "/api/v1/metakeys/product-bundle",
  },

  report: {
    orderReport: "/api/v1/reports/orders",
  },

  order: {

    getPriority: "/api/v1/metakeys?page=0&size=1000",
    userOrder: "/api/v1/orders/by-user",
    userOrderCbd: "/api/v1/orders",
    changeStatus: "/api/v1/orders/status",
    getArchiveOrderById: "/api/v1/order-archiveds",
    adminOrder: "/api/v1/orders/by-admin",
    getProductTypeId: "/api/v1/metakeys/productype-id",
    getOrderByIdUser: "/api/v1/orders",
    getOrderByIdAdmin: "/api/v1/orders",
    getSegmentByIdOrder: "/api/v1/order-taskings/oneatlas/attempts",
    getSchemaCosmos: "/api/v1/orders/cosmos/tasking/opportunity-search",
    getProduction: "/api/v1/metakeys/option-per-product-type",
    confirmOrderTaskingAdmin: "/api/v1/order-taskings/oneatlas/order",
    getProductionSpectralProcessing:
      "/api/v1/metakeys/option-per-product-type-v2",
    approveArchiveOrder: "/api/v1/order-archiveds/body/status",
  },
  metaKey: {
    default: "/api/v1/metakeys",
  },
  project: {
    url: "/api/v1/projects",
    getMyProjects: "/api/v1/projects",
  },
  globalConfig: {
    url: "/api/v1/global-config",
  },
  orderTasking: {
    orderUser: "/api/v1/orders/by-user",
    orderUserCbd: "/api/v1/orders",
    orderAdmin: "/api/v1/orders/by-admin",
    updateStatus: "/api/v1/order-taskings/oneatlas/order/status",
    getDetailOrderTaskingByUer: "/api/v1/orders",
    getDetailOrderTaskingByAdmin: "/api/v1/orders",
    getDownload: "/api/v1/downloads/order"
  },

  basemap: {
    url: "/api/v1/basemaps",
  },

  organization: {
    url: "/api/v1/organizations",
  },

  feedback: {
    getList: '/api/v1/tickets',
    addList: '/api/v1/tickets',
  },
  history: {
    getListUpdate: '/api/v1/loggings',
    getListDownload: '/api/v1/history-downloads'
  },
  dashboard: {
    getData: '/api/v1/statistics'
  },
  config: {
    detail: '/api/v1/configs',
  },
  user: {
    me: '/api/v1/users/me',
  },
  menu: {
    visible: '/api/v1/menus/visible',
  }
};
